export default "__VITE_ASSET__DmPmj7vj__"